<template>
  <v-select
    v-model="selectedDriver"
    placeholder="Search drivers"
    label="phoneNumber"
    :options="filteredDrivers"
    :clearable="clearable"
    :filterable="filterable"
    v-bind="$attrs"
    @search="fetchDrivers"
    @input="selectDriver"
  />
</template>

<script>
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'
import { debounce } from 'lodash'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import driversStore from '../driverStoreModule'

export default {
  components: {
    vSelect,
  },
  props: {
    autoReset: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('drivers', driversStore)
    const selectedDriver = ref(null)
    const filteredDrivers = ref([])
    const fetchDrivers = debounce(async (search, loading) => {
      if (!search) return
      loading(true)
      let temp = search
      if (search.startsWith('00')) {
        temp = `+${search.substr(2)}`
      }
      const res = await ctx.root.$store.dispatch('drivers/fetchDrivers', {
        text: temp,
      })
      filteredDrivers.value = res.drivers
      loading(false)
    }, 1000)

    const selectDriver = e => {
      if (e) {
        ctx.emit('drivers-selection', e)
        if (props.autoReset) {
          selectedDriver.value = null
        }
      }
    }
    filteredDrivers.value.push({
      label: 'phoneNumber',
      value: props.value,
    })
    selectedDriver.value = props.value

    return {
      fetchDrivers,
      filteredDrivers,
      selectDriver,
      selectedDriver,
    }
  },
}
</script>
